/**
 * "Privacy settings" buttons (data-privacy-settings) reopen the consent
 * banner from AdSense's Privacy & messaging, so visitors can change their
 * choice. Queued, as the banner's script may still be loading.
 *
 * They (and anything else marked data-consent-message-only) start hidden and
 * are only shown once Google confirms there's a banner to reopen. There's none
 * outside the UK, EEA and Switzerland, or while AdSense is reviewing the site.
 */

const queueConsentCallback = (callbacks) => {
    window.googlefc = window.googlefc || {}
    window.googlefc.callbackQueue = window.googlefc.callbackQueue || []
    window.googlefc.callbackQueue.push(callbacks)
}

queueConsentCallback({
    CONSENT_DATA_READY: () =>
        window.__tcfapi('getTCData', 2, (data, success) => {
            if (!success || !data.gdprApplies) return
            document
                .querySelectorAll('[data-consent-message-only]')
                .forEach((element) => (element.hidden = false))
        }),
})

document.addEventListener('click', (event) => {
    if (!event.target.closest('[data-privacy-settings]')) return

    queueConsentCallback({
        CONSENT_DATA_READY: () => window.googlefc.showRevocationMessage(),
    })
})
